module.exports = "/static/assets/603107a7e5f62e4f9677616d9cc0afec.png";